const lazy = {
  mounted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        el.src = binding.value;
        observer.unobserve(el);
      }
    });
    observer.observe(el);
  }
};
export default lazy;
// 使用：<img v-lazy="'https://example.com/real-image.jpg'" src="loading.gif" />